module.exports = __webpack_public_path__ + "img/upmoodwatch2.0e0bd9d6.png";